export function getActiveValue(values) {

  if (values.length === 0) {
    return { label: '' };
  }

  return values[0];

}

export function getSelectedEntries(value) {

  if (value.label === '') {
    return [];
  }

  return [value];

}